import React, { useRef, useEffect, useState } from 'react';

import { Button } from 'react-bootstrap';

import MessageChat from './Message';
import ImageListClipboard from './ImageListClipboard';
import SendMessage from './SendMessage';
import ErrorBoundaries from '../ErrorBoundaries';

import {
  MessageGroup,
  MessageGeneric,
  Message,
} from '../../interfaces/IMessage';
import {
  ImageClipboardProvider,
  useImageClipboard,
} from '../../hooks/imageClipboard';

interface Messages {
  seqAtendimento: number;
  messages: Message[];
}

interface Props {
  messages: Messages;
  messagesGroup: any;
  readOnly: boolean;
  searchTextMessage: string;
}

const MessageContainer: React.FC<any> = ({
  messages,
  messagesGroup,
  readOnly,
  searchTextMessage,
}: Props) => {
  const messageRef = useRef<HTMLDivElement>(null);
  const [mensagemGeneric, setMensagemGeneric] = useState<MessageGeneric[]>([]);
  const [showModalImageChat, setShowModalImageChat] = useState(false);
  const [urlImageChat, setUrlImageChat] = useState('');
  const { imageFile } = useImageClipboard();

  const seqUsuario = localStorage.getItem('@LiveChat:seqUsuario');

  useEffect(() => {
    setMensagemGeneric([]);

    if (messagesGroup !== undefined) {
      Object.keys(messagesGroup.messages).forEach((item: any) => {
        const msg: MessageGeneric = {
          id: messagesGroup.messages[item].seqGrupoConversa,
          chatGroup: true,
          seqUsuario: messagesGroup.messages[item].seqUsuario,
          texto: messagesGroup.messages[item].texto,
          seqMensagem: messagesGroup.messages[item].seqGrupoConversaMensagem,
          dtEnvioMensagem: messagesGroup.messages[item].dtEnvioMensagem,
          nomeUsuario: messagesGroup.messages[item].nomeUsuario,
          nomeCliente: '',
          seqMensagemCitacao: messagesGroup.messages[item].seqMensagemCitacao,
          mensagemCitacao: messagesGroup.messages[item].textoCitacao,
          seqMensagemOrigem: messagesGroup.messages[item].seqMensagemOrigem,
          mensagemOrigem: messagesGroup.messages[item].textoOrigem,
          ativo: messagesGroup.messages[item].ativo,
          cor: messagesGroup.messages[item].cor,
        };

        setMensagemGeneric((m) => [...m, msg]);
      });
    }

    if (messages !== undefined) {
      Object.keys(messages.messages).forEach((item: any) => {
        const msg: MessageGeneric = {
          id: messages.messages[item].seqAtendimento,
          chatGroup: false,
          seqUsuario: messages.messages[item].seqUsuario,
          texto: messages.messages[item].texto,
          seqMensagem: messages.messages[item].seqMensagem,
          dtEnvioMensagem: messages.messages[item].dtEnvioMensagem,
          nomeUsuario: messages.messages[item].nomeUsuario,
          nomeCliente: messages.messages[item].nomeCliente,
          seqMensagemCitacao: messages.messages[item].seqMensagemCitacao,
          mensagemCitacao: messages.messages[item].mensagemCitacao,
          seqMensagemOrigem: messages.messages[item].seqMensagemOrigem,
          mensagemOrigem: messages.messages[item].mensagemOrigem,
          ativo: messages.messages[item].ativo,
          cor: '',
        };

        setMensagemGeneric((m) => [...m, msg]);
      });
    }
  }, [messages, messagesGroup]);

  useEffect(() => {
    if (messageRef && messageRef.current && !readOnly) {
      const { scrollHeight, clientHeight } = messageRef.current;
      messageRef.current.scrollTo({
        left: 0,
        top: scrollHeight - clientHeight,
        behavior: 'auto',
      });
    }
  }, [mensagemGeneric]);

  useEffect(() => {
    const imgElements = document.querySelectorAll('.clickable-img');

    function handleExibeImagamChat(src: string): void {
      setUrlImageChat(src);
      setShowModalImageChat(true);
    }

    imgElements.forEach((img) => {
      const src = String(img.getAttribute('src'));

      img.removeEventListener('click', () => handleExibeImagamChat(src));
      img.addEventListener('click', () => handleExibeImagamChat(src));
    });
  }, [mensagemGeneric]);

  return (
    <div className="d-flex flex-column pt-1 pb-1" style={{ flex: 1 }}>
      <div
        className={`position-fixed text-center bg-dark bg-opacity-75 d-flex justify-content-center align-items-center ${
          !showModalImageChat ? 'visually-hidden' : ''
        }`}
        style={{
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <div
          className="position-absolute d-flex flex-row text-center bg-dark bg-opacity-50 overflow-auto border-1 rounded-3"
          style={{
            maxWidth: '80vw',
            maxHeight: '80vh',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <div className="overflow-auto h-100">
            <img
              className="m-3"
              src={urlImageChat}
              style={{ maxHeight: '100%', maxWidth: '80rem' }}
              alt="imagem chat"
            />

            <Button
              variant="warning"
              className="ms-1 me-4 mb-3"
              style={{ maxWidth: '10rem' }}
              onClick={() => {
                setShowModalImageChat(!showModalImageChat);
              }}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>

      <div
        className="d-flex flex-column border rounded shadow p-1 bg-body pb-1"
        style={{ flex: 1 }}
      >
        <div
          ref={messageRef}
          className="d-flex flex-column overflow-auto"
          style={{ flex: 1 }}
        >
          <div className="d-flex flex-column" style={{ height: '1rem' }}>
            {Object.keys(mensagemGeneric).length > 0
              ? mensagemGeneric.map((message: MessageGeneric) => {
                  return (
                    <MessageChat
                      key={message.seqMensagem}
                      message={message}
                      readOnly={readOnly}
                      seqUsuario={seqUsuario}
                      searchTextMessage={searchTextMessage}
                    />
                  );
                })
              : null}
          </div>
        </div>
        {!readOnly && (messagesGroup !== undefined || messages !== undefined) && (
          // <ErrorBoundaries>
          <SendMessage
            idSupportRequest={
              messages !== undefined ? messages.seqAtendimento : 0
            }
            seqGrupoConversa={
              messagesGroup !== undefined ? messagesGroup.seqGrupoConversa : 0
            }
          />
          // </ErrorBoundaries>
        )}
      </div>
    </div>
  );
};

export default MessageContainer;
